import { render, staticRenderFns } from "./layout-block.vue?vue&type=template&id=9cd7009a&scoped=true"
import script from "./layout-block.vue?vue&type=script&lang=js"
export * from "./layout-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd7009a",
  null
  
)

export default component.exports